<div class="edit-violation-rule">
  <app-popup-top-line></app-popup-top-line>
  <div class="edit-violation-rule-header">
    <div class="title">
      {{ 'violationRulesPage.edit.title' | labelsProvider }}
    </div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="closeClick()" />
  </div>
  <div class="edit-violation-rule-body">
    <div class="toggle-box-container">
      <div class="toggle-box-title">
        {{ 'violationRulesPage.edit.changeStatus' | labelsProvider }}
      </div>
      <div class="toggle-box">
        <app-on-off-toggle [isOn]="status === RuleStatus.on" (toggleOnClick)="onStatusSelected($event)">
        </app-on-off-toggle>
      </div>
    </div>
    <div class="severity-change">
      <app-selection-buttons-container
        [buttonsArrayBehaviorSubject]="severitySelectionButtons"
        title="{{ 'violationRulesPage.edit.changeSeverity' | labelsProvider }}"
        (buttonOnClick)="onSeveritySelected($event)"
      >
      </app-selection-buttons-container>
    </div>
  </div>
  <div class="disclaimer">* Changes will be applied immediately and be reflected in Zenity within 24h</div>
  <div class="edit-violation-rule-footer">
    <div class="buttons">
      <button class="cancel" (click)="closeClick()">
        {{ 'common.cancel' | labelsProvider }}
      </button>
      <button
        class="confirm"
        [ngClass]="{
          'confirm-disabled':
            (severity === violationRuleData.severity && status === violationRuleData.status) ||
            updateViolationRuleInProgress,
        }"
        (click)="saveChanges()"
        cdkFocusInitial
      >
        <span *ngIf="!updateViolationRuleInProgress">{{ 'common.save' | labelsProvider }}</span>
        <mat-progress-spinner
          class="spinner"
          *ngIf="updateViolationRuleInProgress"
          color="primary"
          mode="indeterminate"
        >
        </mat-progress-spinner>
      </button>
    </div>
  </div>
</div>
